import React, { useEffect, useState } from 'react';
import {
	postWebAuthnFaLoginChallenge,
	postWebAuthnFaLoginComplete,
} from '../../Services/users';

const base64ToArrayBuffer = (b64: string): ArrayBuffer => {
	const binaryString = window.atob(b64.replace(/-/g, '+').replace(/_/g, '/'));
	const bytes = new Uint8Array(binaryString.length);
	for (let i = 0; i < binaryString.length; i++) {
		bytes[i] = binaryString.charCodeAt(i);
	}
	return bytes.buffer;
};

const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
	return btoa(String.fromCharCode(...new Uint8Array(buffer)))
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.replace(/=+$/, '');
};

export const WebAuthnLogin = () => {
	const [status, setStatus] = useState('');

	const handleWebAuthnLogin = async () => {
		setStatus('Chargement du challenge...');

		try {
			const options = await postWebAuthnFaLoginChallenge();

			// Transforme les buffers base64 -> ArrayBuffer
			options.publicKey.challenge = base64ToArrayBuffer(
				options.publicKey.challenge
			);
			options.publicKey.allowCredentials =
				options.publicKey.allowCredentials.map((cred: any) => ({
					...cred,
					id: base64ToArrayBuffer(cred.id),
				}));

			const credential = (await navigator.credentials.get({
				publicKey: options.publicKey,
			})) as PublicKeyCredential;

			const authResponse =
				credential.response as AuthenticatorAssertionResponse;

			const data = {
				id: credential.id,
				rawId: arrayBufferToBase64(credential.rawId),
				type: credential.type,
				response: {
					clientDataJSON: arrayBufferToBase64(authResponse.clientDataJSON),
					authenticatorData: arrayBufferToBase64(
						authResponse.authenticatorData
					),
					signature: arrayBufferToBase64(authResponse.signature),
					userHandle: authResponse.userHandle
						? arrayBufferToBase64(authResponse.userHandle)
						: null,
				},
			};

			const finalRes = await postWebAuthnFaLoginComplete(data);

			if (!finalRes.ok) {
				throw new Error(finalRes.message || "Échec de l'authentification");
			}

			setStatus('Authentification réussie !');
		} catch (err: any) {
			setStatus('Échec : ' + err.message);
		}
	};

	useEffect(() => {
		handleWebAuthnLogin();
	}, []);

	return <div>{status}</div>;
};
